import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "home",
        component: Home,
    },
    {
        path: "/students",
        name: "students",
        component: () =>
            import ("@/views/Student")
    },
    // {
    //     path: "/alumni",
    //     name: "alumni",
    //     component: () =>
    //         import ("@/views/Alumni")
    // },
    {
        path: "/faculty",
        name: "faculty",
        component: () =>
            import ("@/views/Faculty")
    },
    {
        path: "/acemap",
        name: "acemap",
        component: () =>
            import ("@/views/Project.vue")
    },
    {
        path: "/iiot",
        name: "iiot",
        component: () =>
            import ("@/views/Project.vue")
    },
    {
        path: "/GeoScience",
        name: "GeoScience",
        component: () =>
            import ("@/views/Project.vue")
    },
    {
        path: "/ai",
        name: "ai",
        component: () =>
            import ("@/views/Project.vue")
    },
    {
        path: "/socialscience",
        name: "socialscience",
        component: () =>
            import ("@/views/Project.vue")
    },
    {
        path: "/security",
        name: "security",
        component: () =>
            import ("@/views/Project.vue")
    },


    {
        path: "/publication",
        name: "publication",
        component: () =>
            import ("@/views/Publication.vue")
    },
    {
        path: '/recruitment',
        name: 'recruitment',
        component: () =>
            import ("@/views/Recruitment.vue")
    },
    {
        path: '/alumni',
        name: 'alumni',
        component: () =>
            import ("@/views/StudentMap.vue")
    },
    // {
    //     path: '/photo',
    //     name: 'photo',
    //     component: () =>
    //         import ("@/views/Photos.vue")
    // },
    {
        path: '/course',
        name: 'course',
        component: () =>
            import ("@/views/Course.vue")
    },
    {
        path: '/academic',
        name: 'academic',
        component: () =>
            import ("@/views/Photos/academic.vue")
    },
    {
        path: '/life',
        name: 'life',
        component: () =>
            import ("@/views/Photos/index.vue")
    },
    {
        path: '/talk',
        name: 'talk',
        component: () =>
            import ("@/views/Talk.vue")
    },
    {
        path: '/spiritual',
        name: 'spiritual',
        component: () =>
            import ("@/views/Photos/index.vue")
    },
    {
        path: '/xtian',
        name: 'xtian',
        component: () =>
            import ("@/views/Teachers/xtian.vue")
    },
    {
        path: '/xygan',
        name: 'xygan',
        component: () =>
            import ("@/views/Teachers/xygan.vue")
    }
];

const router = new VueRouter({
    // mode: "history",
    // base: process.env.BASE_URL,
    routes,
});

export default router;